import { View } from "react-native";
import { Image } from "expo-image";
import { Stack, useLocalSearchParams, useNavigation } from "expo-router";

import { HeaderX } from "~/components/HeaderElements";
import { blurhash } from "~/lib/constants";
import { useAccountStore } from "~/stores/space";

export default function ImagePreview() {
  const params = useLocalSearchParams<{ spaceId: string; saveId: string }>();

  const { store } = useAccountStore();
  const save = store.spaceById(params.spaceId!)?.saveById(params.saveId!);

  const navigation = useNavigation();
  if (!save) throw new Error("Save not found");
  if (save.type !== "MEDIA") throw new Error("Save is not a media type");

  return (
    <View className="h-full w-full flex-1">
      <Stack.Screen
        options={{
          headerTitle: save.title || save.meta?.fileName,
          headerBackTitleVisible: false,
          headerBackVisible: true,
          headerRight: () => (
            <HeaderX
              onPress={() => {
                navigation.goBack();
              }}
            />
          ),
        }}
      />
      <Image
        style={{
          resizeMode: "contain",
          height: "100%",
          width: "100%",
        }}
        source={{ uri: save.meta?.uri }}
        alt={save.meta?.fileName}
        placeholder={blurhash}
      />
    </View>
  );
}
